'use strict';
/*!
 * select-option-redirect
 *
 * For <select> element, when you want to redirect to url set as value in option.
 *
 * @package krobot
 * @deps jquery
 */

const $ = jQuery;

$( 'select.with-redirect' ).change( function() {
	if ( $( this ).val() !== '' ) {
		window.location.href = $( this ).val();
	}
} );
